import Amap from '../Amap';
import './index.css';

export default {
  name: 'Bmap',
  render() {
    const { mapStyle = 'amap://styles/3c227c09b6ee2f827d977bd2f7ce4ddd', ...attrs } = this.$attrs;
    return (<Amap mapStyle={mapStyle} {...{ attrs }} />)
  }
}